<template>
  <button
    :type="type"
    :class="['button', { large: large, secondary: secondary }, 'text-center']"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
    <div v-show="spinner" class="spinner spinner-button" />
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  emits: ['click'],
  props: {
    large: {
      type: Boolean,
      default() {
        return false;
      }
    },
    secondary: {
      type: Boolean,
      default() {
        return false;
      }
    },
    spinner: {
      type: Boolean,
      default() {
        return false;
      }
    },
    type: {
      type: String,
      default() {
        return 'button';
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    }
  }
};
</script>
